export default __webpack_public_path__ + "static/media/site_safaye.b9e4a8fc.webp";